import http from "../index"
import {
  apiBrowseOrderB2B,
  apiCreateOrderB2B,
  apiDetailOrderB2B,
  apiGetAllOrderB2B,
  apiRefuseOrderB2B,
  apiUpdateOrderB2B,
  apiGetAllHistoryOrderB2B,
  apiDetailHistoryOrderB2B,
  apiGetPriceSim,
  apiGetPackageListAll,
  apiGetPackageList,
  apiGetOrderAgency,
  apiCreateOrderAgency,
  apiGetOrderAgencyChild,
  apiBrowseOrderAgencyChild,
  apiRefuseOrderAgencyChild,
  apiBrowseOrderAgencyByParent,
  apiRefuseOrderAgencyByParent,
  apiGetPackagePrice,
  apiCreatePackagePrice,
  apiGetBoughtPackage,
  apiUpdateOrderAgency,
  apiGetListUserDiscount,
  apiUpdateUserPrice,
  apiGetPackageHistory,
  apiSearchBuyData,
  apiPullBuyData,
  apiListPackageSaleType,
  apiChooseModePackageSaleType,
  apiGetPackagePriceDetail,
  apiSetOverridePackagePrice,
  apiSetBasePackagePrice,
  apiSetCommission,
} from "./urls"
const getListAllOrder = params => http.get(apiGetAllOrderB2B, { params })
const getDetailOrder = id => http.get(apiDetailOrderB2B(id))
const browseOrderB2B = id => http.put(apiBrowseOrderB2B(id))
const refuseOrderB2B = (id, body) => http.put(apiRefuseOrderB2B(id), body)
const createOrderB2B = body => http.post(apiCreateOrderB2B, body)
const updateOrderB2B = (id, body) => http.put(apiUpdateOrderB2B(id), body)
const getListAlHistorylOrder = params =>
  http.get(apiGetAllHistoryOrderB2B, { params })
const getDetailHistorylOrder = id => http.get(apiDetailHistoryOrderB2B(id))
const getPriceSim = params => http.get(apiGetPriceSim, { params })
const getPackageList = params => http.get(apiGetPackageListAll, { params })
const getPackageListLeader = params => http.get(apiGetPackageList, { params })
const getOrderAgency = params => http.get(apiGetOrderAgency, { params })
const createOrderAgency = body => http.post(apiCreateOrderAgency, body)
const updateOrderAgency = (id, body) => http.put(apiUpdateOrderAgency(id), body)
const getOrderAgencyChild = params =>
  http.get(apiGetOrderAgencyChild, { params })
const browseOrderAgencyChild = id => http.put(apiBrowseOrderAgencyChild(id))
const refuseOrderAgencyChild = (id, body) =>
  http.put(apiRefuseOrderAgencyChild(id), body)

const browseOrderAgencyByParent = id =>
  http.put(apiBrowseOrderAgencyByParent(id))
const refuseOrderAgencyByParent = (id, body) =>
  http.put(apiRefuseOrderAgencyByParent(id), body)
const getPackagePrice = params => http.get(apiGetPackagePrice, { params })
const createPackagePrice = body => http.post(apiCreatePackagePrice, body)
const getBoughtPackage = params => http.get(apiGetBoughtPackage, { params })
const getListUserDiscount = params =>
  http.get(apiGetListUserDiscount, { params })
const updateUserDiscount = body => http.put(apiUpdateUserPrice, body)
const getPackageHistory = params => http.get(apiGetPackageHistory, { params })
const searchBuyData = body => http.post(apiSearchBuyData, body)
const pullBuyData = body => http.post(apiPullBuyData, body)
const listPackageSaleType = params =>
  http.get(apiListPackageSaleType, { params })
const settingSaleType = body => http.post(apiChooseModePackageSaleType, body)
const getPackagePriceDetail = id => http.get(apiGetPackagePriceDetail(id))
const setOverridePackagePrice = body =>
  http.post(apiSetOverridePackagePrice, body)
const setBasePackagePrice = body => http.post(apiSetBasePackagePrice, body)
const setCommission = body => http.post(apiSetCommission, body)
const OrderB2BService = {
  getListAllOrder,
  getDetailOrder,
  browseOrderB2B,
  refuseOrderB2B,
  createOrderB2B,
  updateOrderB2B,
  getListAlHistorylOrder,
  getDetailHistorylOrder,
  getPriceSim,
  getPackageList,
  getPackageListLeader,
  getOrderAgency,
  createOrderAgency,
  updateOrderAgency,
  getOrderAgencyChild,
  browseOrderAgencyChild,
  refuseOrderAgencyChild,
  browseOrderAgencyByParent,
  refuseOrderAgencyByParent,
  getPackagePrice,
  createPackagePrice,
  getBoughtPackage,
  getListUserDiscount,
  updateUserDiscount,
  getPackageHistory,
  searchBuyData,
  pullBuyData,
  listPackageSaleType,
  settingSaleType,
  getPackagePriceDetail,
  setOverridePackagePrice,
  setBasePackagePrice,
  setCommission,
}

export default OrderB2BService
